import { MenuItem } from 'shared';

import { useDeleteGoal } from 'features/goal';

import { Typography } from 'shared/components/Typography';

type TGoalDeleteButton = {
  goalId: string;
  columnId: string;
};

export const GoalMenuDeleteButton = ({
  goalId,
  columnId,
}: TGoalDeleteButton) => {
  const { onDeleteGoalClick } = useDeleteGoal({ goalId, columnId });

  return (
    <MenuItem
      onClick={(event: MouseEvent) => {
        event.preventDefault();
        onDeleteGoalClick();
      }}
    >
      <Typography color="red">Delete goal</Typography>
    </MenuItem>
  );
};
